<template>
  <div class="fill-height pb-6">
    <div class="d-flex flex-column pa-0">
      <div class="flex-1 mb-5" @click="onClickHeader">
        <span class="cursor-pointer text-uppercase tcdc-menu-title bold">{{title}}</span>
      </div>
      <template v-for="(item, i) in items">
        <div :key="i" class="menu-expandable">
          <div class="px-0 tcdc-panel-header" @click="() => onClick(item)">
            <span
              class="white--text text-capitalize tcdc-menu-content menu-highlight"
            >{{ item[`name_${lang}`] }}</span>
          </div>
          <div :class="{'mb-5': item.subMenuList && item.subMenuList.length > 0}">
            <template v-for="(item, index) of item.subMenuList">
              <div
                :key="index"
                class="text-capitalize tcdc-menu-content"
                @click="() => onClickSubMenu(item)"
                style="padding-left: 15px;font-size: 15px"
              > {{item[`name_${lang}`]}}</div>
            </template>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
// import MenuDivider from "../dividers/MenuDivider";
import { mapState } from 'vuex';
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    items: {
      type: Array
    }
  },
  components: {
    // MenuDivider
  },
  computed: {
    ...mapState({
      lang: state => state.Branch.lang
    })
  },
  methods: {
    onClickHeader() {
      this.$emit("onClickHeader");
    },
    onClick(item) {
      this.$emit("onClick", item);
    },
    onClickSubMenu(item) {
      this.$emit("onClickSubMenu", item);
    }
  }
};
</script>

<style lang="scss">
.menu-expandable {
  background-color: black !important;
}
</style>
